import { Navigate, useLocation } from 'react-router';
import { useAppSelector } from '../store/hooks';

/**
 * A wrapper component that redirects to the login page if the user is not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  if (!isAuthenticated) {
    // Redirect to the login page, but save the current location they were trying to access
    return <Navigate to="/borrower/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
